import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import App from './App.tsx'
import { registerServiceWorker } from './pwa/registerServiceWorker'
import { initTheme } from './utils/theme'

// PostHog project API key is intentionally public (embedded in all browser pages by design)
posthog.init(import.meta.env.VITE_POSTHOG_KEY || 'phc_oNXM5kJ3bZfJSMohhw3gCos6XaYDsNSQfL4H7fPFRNAS', {
  api_host: '/ingest',
  ui_host: 'https://eu.posthog.com',
  person_profiles: 'identified_only',
  session_recording: {
    maskAllInputs: true,
    maskInputOptions: { password: true },
  },
  // capture_pageview: false — manual $pageview in usePageTracking normalises UUID paths
  capture_pageview: false,
  capture_pageleave: true,
  autocapture: true,
});

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: true,
});

// Apply saved theme before first render to avoid flash of wrong theme
initTheme()
registerServiceWorker()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
